import React from 'react'

import { getPriceTableTitle } from '../../messages/components-messages'

const PriceTable = ({ accommodation, showAccommodationTitle }) => {
  const headers = accommodation.priceTableHeaders 
  const lines = accommodation.priceTableLines 
  const infos = accommodation.priceInfos
  const title = showAccommodationTitle ? `${getPriceTableTitle()} - ${accommodation.title}` : getPriceTableTitle()

  return (
    <section id="prices" className="prices">
        <header className="major">
            <h2>{title}</h2>
        </header>
        <div className="table-wrapper">
            <table className="alt">
                <thead>
                    <tr>
                        {
                          headers.map(header => (<th key={header}>{header}</th>))
                        }
                    </tr>
                </thead>
                <tbody>
                  { 
                    lines.map((line, j) => {
                      const cellContent = line.map((cell, i) => 
                        <td key={cell.text + '_' + i}>
                          <span style={{fontWeight: 100, margin: 0}}>{cell.text}</span>
                          { cell.description &&  <><br/><span style={{fontWeight: 100, margin: 0, fontSize: 'smaller'}}>{cell.description}</span></> }
                        </td>
                      )
                      
                      return <tr key={'line_' + j}>{cellContent}</tr>
                    })
                  }
                </tbody>
            </table>
        </div>
        {
          infos && infos.map(info => (
            <div key={info}>
              <br/>
              <span className="icon fa-info-circle"/>
              <span>{info}</span>
              <br/>
            </div>
          ))
        }
    </section>
  )
}

PriceTable.defaultProps = {
  headers: [],
  lines: [[]],
  infos: [],
  showAccommodationTitle: false
}

export default PriceTable